import type { NetworkTelemetryRow } from "@features/reports/api";
import type { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";

import { formatNumber } from "./formatNumber";
import type { CoefficientMode } from "./store";

const timeColumn = {
  title: "Время",
  dataIndex: "timestamp",
  width: 180,
  render: (value: string) => dayjs(value).format("DD.MM.YYYY HH:mm"),
};

const channelsColumn = {
  title: "Каналы",
  dataIndex: "channels_count",
  width: 110,
};

const fmt = (value?: number) => formatNumber(value);

const scaledColumns = [
  { title: "kW (С Кт × Кн)", dataIndex: "kw", width: 150, render: fmt },
  { title: "kvar (С Кт × Кн)", dataIndex: "kvar", width: 150, render: fmt },
  { title: "I (С Кт × Кн)", dataIndex: "i", width: 130, render: fmt },
];

const rawColumns = [
  { title: "kW (Без Кт × Кн)", dataIndex: "kw_raw", width: 150, render: fmt },
  { title: "kvar (Без Кт × Кн)", dataIndex: "kvar_raw", width: 150, render: fmt },
  { title: "I (Без Кт × Кн)", dataIndex: "i_raw", width: 150, render: fmt },
];

export const getNetworkTelemetryColumns = (
  coefficient: CoefficientMode,
): ColumnsType<NetworkTelemetryRow> => {
  const dataColumns = coefficient === "with" ? scaledColumns : rawColumns;
  return [timeColumn, ...dataColumns, channelsColumn];
};
